import { useEffect, useState } from "react";
import { catalogApi } from "../api/endpoints";
import { useDebouncedValue } from "./useDebouncedValue";

/** Only the current text owns the result; late replies and polls are discarded. */
export function useProductStockSearch(value, enabled) {
  const query = value.trim();
  const term = useDebouncedValue(query, 500);
  const [state, setState] = useState(null);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!enabled || term.length < 2 || term !== query) return;
    let active = true;
    let timer;
    const started = Date.now();
    const accept = async (promise) => {
      try {
        const data = await promise;
        if (!active) return;
        setState({ query, attempt, data });
        if (data.pending) {
          if (!data.checkId || Date.now() - started >= 110_000) throw Error("stock_timeout");
          timer = setTimeout(() => { if (active) void accept(catalogApi.pollStock(data.checkId)); }, 1500);
        }
      } catch {
        if (active) setState({ query, attempt, error: true });
      }
    };
    void accept(catalogApi.checkStock(term));
    return () => { active = false; clearTimeout(timer); };
  }, [enabled, term, query, attempt]);
  const current = state?.query === query && state?.attempt === attempt ? state : null;
  return { ...current, loading: enabled && query.length >= 2 && !current,
    retry: () => setAttempt(value => value + 1) };
}
